const BOOKING_SESSION_COLLECTION = "booking_session";

const extractSnapshotData = (snap) => {
  if (!snap.exists) {
    return null;
  }

  return {
    id: snap.id,
    ...snap.data()
  };
};

function BookingSessionMixin() {
  return {
    async getBookingSessionWithId(bookingSessionId) {
      return await this.collection(BOOKING_SESSION_COLLECTION)
        .doc(bookingSessionId)
        .get()
        .then(extractSnapshotData);
    },
    async createBookingSession(data) {
      const ref = await this.collection(BOOKING_SESSION_COLLECTION).add(data);
      const bookingSession = {
        id: ref.id,
        ...data
      };
      return bookingSession;
    },
    async updateBookingSession(bookingSessionId, bookingSessionData) {
      return await this.collection(BOOKING_SESSION_COLLECTION)
        .doc(bookingSessionId)
        .set(bookingSessionData, { merge: true });
    }
  };
}

module.exports = BookingSessionMixin;
